import { Chip } from '@mui/material';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  EmailField,
  BooleanField,
  FunctionField,
  ShowButton,
  TopToolbar,
  FilterButton,
  TextInput,
  SelectInput,
} from 'react-admin';
import { User } from 'src/models';
import { formatPhoneNumber } from 'src/utils';

export const hasAccountsChoiceList = [
  { id: 'true', name: 'Yes' },
  { id: 'false', name: 'No' },
];

export const UserListFilters = [
  <TextInput key='firstName' label='First name' source='firstName' />,
  <TextInput key='lastName' label='Last name' source='lastName' />,
  <TextInput key='email' label='Email' source='email' />,
  <TextInput key='phoneNumber' label='Phone number' source='phoneNumber' />,
  <SelectInput key='hasAccounts' label='Created account(s)' source='hasAccounts' choices={hasAccountsChoiceList} />,
];

export const UserList = () => (
  <List
    title='Users'
    filters={UserListFilters}
    sort={{ field: 'createdAt', order: 'DESC' }}
    actions={
      <TopToolbar>
        <FilterButton />
      </TopToolbar>
    }>
    <Datagrid bulkActionButtons={false}>
      <TextField source='id' sortable={false} />
      <TextField source='firstName' />
      <TextField source='lastName' />
      <EmailField source='email' />
      <FunctionField label='Phone number' render={(user: User) => formatPhoneNumber(user.phoneNumber)} />
      <FunctionField
        label='Created account(s)'
        render={(user: User) => {
          if (user.hasAccounts) {
            return <Chip label='Yes' color='success' />;
          }

          return <Chip label='No' color='error' />;
        }}
      />
      <BooleanField source='isClosed' />
      <BooleanField source='isLocked' />
      <DateField source='createdAt' label='Created at' />
      <ShowButton label='Show' />
    </Datagrid>
  </List>
);
